<section data-topNavComponent>
  <header class="print--show" aria-hidden="true">
    <img src="../assets/images/ontario@2x-print.png" alt="{{ 'home.topnav.logo.ontario.alttext' | translate | async }}" aria-hidden="true" />
    <h1 class="h1 h1--page-title">AgriSuite <span class="expanded-title">{{ navTitle }}</span></h1>
    <div class="clear" aria-hidden="true"></div>
  </header>
  <mat-sidenav-container [style.overflow]="sideNavOpened ? 'visible' : 'hidden'" [style.z-index]="sideNavOpened ? '1' : '0'">
    <mat-sidenav
      #drawer
      class="sidenav display--block"
      fixedInViewport="true"
      tabindex="0"
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="'top'"
      [autoFocus]="true"
      [opened]="sideNavOpened"
      position="end">
      <mat-toolbar>
        <mat-toolbar-row class="flex flex--cols-2">
          <h2 class="h2 flex-child flex-child--flex-grow">
            {{ "home.topnav.sidenav.menu.title" | translate | async }}
          </h2>
          <div class="flex-child flex-child--flex-shrink">
            <button
              type="button"
              mat-icon-button
              class="button button--black-tertiary"
              tabindex="0"
              (click)="drawer.close()"
              matTooltip="{{ 'home.topnav.sidenav.menu.tooltip.close' | translate | async }}"
              matTooltipPosition="left">
              <mat-icon
                aria-hidden="false"
                attr.aria-label="{{ 'home.topnav.sidenav.menu.tooltip.close' | translate | async }}"
                mat-icon-button>
                close
              </mat-icon>
            </button>
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
      <mat-nav-list>
        @if ((!isAuthenticated && router.url !== '/') || (isAuthenticated && router.url !== '/secure-home')) {
          <button
            class="button button--green-tertiary"
            mat-list-item
            [tabindex]="0"
            (click)="home()"
            type="button"
            (keydown.enter)="home()"
            >
            {{ "home.topnav.sidenav.menuitem.home" | translate | async }}
          </button>
        }
        @if (isAuthenticated && allowCreateNew) {
          <a mat-list-item [tabindex]="0" (click)="createNew()" (keydown.enter)="createNew()" href="javascript:void(0)">
            {{ "home.topnav.sidenav.menuitem.createNew" | translate | async }}
          </a>
        }
        @if (isAuthenticated && allowCreateNew) {
          <a mat-list-item [tabindex]="0" (click)="import()" (keydown.enter)="import()" href="javascript:void(0)">
            {{ "home.auth.text.import.plan" | translate | async }}
          </a>
        }
        @if (!isAuthenticated) {
          <a mat-list-item [tabindex]="0" (click)="login()" (keydown.enter)="login()" href="javascript:void(0)">
            {{ "home.topnav.sidenav.menuitem.signin" | translate | async }}
          </a>
        }
        @if (!isAuthenticated) {
          <a mat-list-item [tabindex]="0" (click)="signup()" (keydown.enter)="signup()" href="javascript:void(0)">
            {{ "home.topnav.sidenav.menuitem.signup" | translate | async }}
          </a>
        }
        <button type="button" class="button button--green-tertiary" mat-list-item [tabindex]="0" (click)="contactUs()">
          {{ "home.topnav.sidenav.menuitem.contactus" | translate | async }}
        </button>
        <button type="button" class="button button--green-tertiary" mat-list-item [tabindex]="0" (click)="feedback()">
          {{ "dialog.title.feedback" | translate | async }}
        </button>
        @if (isAuthenticated) {
          <a mat-list-item [tabindex]="0" (click)="logout()" (keydown.enter)="logout()" href="javascript:void(0)">
            {{ "home.topnav.sidenav.menuitem.logout" | translate | async }}
          </a>
        }
      </mat-nav-list>

      @if (version) {
        <p class="text-align--center">
          <em>{{ version }}</em>
        </p>
      }
    </mat-sidenav>
    <mat-sidenav-content>
      <div data-header class="print--hide" role="banner">
        <mat-toolbar class="flex flex--cols-3">
          <a href="https://www.ontario.ca/" #ontarioLogo class="flex-child" target="_blank" title="{{ 'home.topnav.logo.ontario.title' | translate | async }}" rel="noopener">
            <img src="../assets/images/ontario.ca.svg" alt="{{ 'home.topnav.logo.ontario.alttext' | translate | async }}" />
          </a>
          <h1 class="h1 h1--page-title flex-child text-align--center">
            <a [routerLink]="routerLinkHome" title="Home" class="main-title"> AgriSuite <span class="expanded-title">{{ navTitle }}</span></a>
          </h1>
          <div data-right-third class="flex-child text-align--right">
            <button
              [attr.lang]="oppositeLanguage"
              type="button"
              mat-icon-button
              class="button button--black-primary locale"
              (click)="switchLanguage()"
              data-language-button
              matTooltip="{{ 'home.topnav.tooltip.language' | translate | async }}"
              matTooltipPosition="left">
              <span [title]="oppositeLanguage === 'en' ? 'English' : 'Français'">
                {{ oppositeLanguage }}
              </span>
            </button>
            <button
              type="button"
              mat-icon-button
              class="button button--black-primary"
              (click)="sideNavOpened = true; drawer.toggle()"
              data-hamburger-menu
              matTooltip="{{ 'home.topnav.sidenav.hamburger.tooltip.text' | translate | async }}"
              matTooltipPosition="above">
              <span class="material-icons"> menu </span>
            </button>
          </div>
        </mat-toolbar>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</section>
